<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-17 14:50:09
 * @LastEditTime : 2020-01-07 09:46:58
 * @LastEditors  : Please set LastEditors
 -->
<template>
  <div class="fengmap">
    <div id="map" ref="map"></div>
  </div>
</template>

<script>
import {
  getLocalStorage
} from '@/utils/auth'
let envCode = getLocalStorage('envCode') ? getLocalStorage('envCode') : '0'
let baseURL = envCode && getLocalStorage('envJson') ? JSON.parse(getLocalStorage('envJson'))[envCode].screenPath + '/proxy_map/' : '/proxy_map/';
let t1 = null;
let fengmap = window.fengmap; // 蜂鸟地图
let map = null; // 蜂鸟地图实例
let compass = null; // 指南针实例
let locationMarker = null; // 定位标注
let imgLayer = {};
let lineLayer = [];
let textLayer = {};
let floors = [];
let startMarker = null;
let endMarker = null;
let tileLayer = null;

export default {
  data () {
    return {
      fmapID: null,
      appName: null,
      key: null,
      mapServerURL: null,
      mapThemeURL: null,
      externalModelURL: null,
      defaultThemeName: null,
      floorListVisible: false,
      defaultFocusGroup: 1,
      clickedPOI: false,
      eventID: null,
      defaultMapScaleLevel: null
    };
  },
  computed: {
    // 当前建筑信息
    buildInfo () {
      return this.$store.state.nav.buildInfo;
    }
  },
  created () {
    this.getFMMapData();
  },
  mounted () {
    console.log('buildInfo', this.buildInfo);
    this.$nextTick(() => {
      t1 = new Date()
      this.initFMMap();
    });
  },
  beforeDestroy () {
    if (map) {
      console.error('地图销毁了');
      map.dispose();
    }
    // 地图销毁后该对象不为null，判断会出错，所以要赋值为null清空，以下同样。
    map = null;
    locationMarker = null;
    // console.log('地图被销毁');
  },
  methods: {
    // 获取地图配置
    getFMMapData () {
       // 获取当前主题对应的版本号，若找不到则使用默认主题版本号
      let themeVersion = this.buildInfo.defTheme ? this.buildInfo.defTheme.versionNo + '/' : ''
      this.fmapID = this.buildInfo.map;
      this.appName = this.buildInfo.mapName;
      this.key = this.buildInfo.mapKey;
      this.mapServerURL = `${baseURL}${this.buildInfo.buildId}/maps/${this.buildInfo.buildVersion}/`; // 地图数据资源路径
      this.externalModelURL = `${baseURL}${this.buildInfo.buildId}/maps/${this.buildInfo.buildVersion}/${this.buildInfo.map}/`; // 地图数据资源路径
      this.themeURL = `${baseURL}${this.buildInfo.buildId}/theme/${themeVersion}`;
      this.defaultThemeName = this.buildInfo.themeNo;
      this.defaultMapScaleLevel = this.buildInfo.initSize || 20; // 设置地图初始大小
      this.defaultFocusGroup = this.buildInfo.initFloor;
    },
    // 初始化地图
    initFMMap () {
      let mapOptions = {
        appName: this.buildInfo.mapName, // 开发者应用名称
        key: this.buildInfo.mapKey, // 开发者申请应用下web服务的key
        container: document.getElementById('map'), // 渲染dom
        mapID: this.buildInfo.map,
        themeID: this.buildInfo.themeNo,
        mapURL: this.mapServerURL, // 地图数据资源路径
        themeURL: this.themeURL, // 地图主题资源路径
        defaultThemeName: this.buildInfo.themeNo,
        zoomRange: [17, 23],
        externalModelURL: this.externalModelURL,
        mapZoom: this.buildInfo.initSize || 20, // 设置地图初始显示比例尺级别。范围为1-29之间的整数值。如29级的比例尺为1:1厘米。
        level: this.buildInfo.initFloor || 1,
        visibleLevels: [this.buildInfo.initFloor || 1],
        // viewMode: fengmap.FMViewMode.MODE_2D,
        tile: true, // 是否分层加载,默认值:true
        preLoad: false,
        highlightPicker: [],
        floorSpace: 50,
        shadingMode: 2,
        backgroundAlpha: 0.00,
        // renderOrder: [EXTENT, EXTERNAL_MODEL, MODEL, DYNAMIC_MODEL_MARKER, EXTRUDE_MARKER, POLYGON_MARKER, HEAT_MAP_MARKER, LINE_MARKER, FACILITY, LABEL, IMAGE_MARKER,TEXT_MARKER, LOCATION_MARKER],
        // renderOrder: [fengmap.FMType.EXTENT, fengmap.FMType.EXTERNAL_MODEL, fengmap.FMType.FACILITY, fengmap.FMType.MODEL, fengmap.FMType.DYNAMIC_MODEL_MARKER, fengmap.FMType.EXTRUDE_MARKER, fengmap.FMType.POLYGON_MARKER, fengmap.FMType.HEAT_MAP_MARKER, fengmap.FMType.LINE_MARKER, fengmap.FMType.LABEL, fengmap.FMType.IMAGE_MARKER, fengmap.FMType.TEXT_MARKER, fengmap.FMType.LOCATION_MARKER]
      };
      console.log('mapOptions', mapOptions);
      map = new fengmap.FMMap(mapOptions);

      // 地图加载完成
      map.on('externalFirstLoaded', () => {
        // 渲染顺序 // 底面 外部模型 公共设施 模型 外部模型 多边形拉伸几何体 多边形 热力图 线标注 文本标签 图片标注 自定义文本标注 定位标注
        // map.setRenderOrder([fengmap.FMType.EXTENT, fengmap.FMType.EXTERNAL_MODEL, fengmap.FMType.FACILITY, fengmap.FMType.MODEL, fengmap.FMType.DYNAMIC_MODEL_MARKER, fengmap.FMType.EXTRUDE_MARKER, fengmap.FMType.POLYGON_MARKER, fengmap.FMType.HEAT_MAP_MARKER, fengmap.FMType.LINE_MARKER, fengmap.FMType.LABEL, fengmap.FMType.IMAGE_MARKER, fengmap.FMType.TEXT_MARKER, fengmap.FMType.LOCATION_MARKER])
        console.log('地图加载需要的时间', new Date().getTime() - t1.getTime());

        // 指南针
        compass = new fengmap.FMCompass({
          backgroundImageSize: 58,
          backgroundImageURL: '/images/preloader/map/Guide.png',
          pointerImageURL: '/images/preloader/map/Needle.png',
          pointerImageSize: 50,
          position: fengmap.FMControlPosition.RIGHT_BOTTOM,
          offset: { x: -13, y: -235 }
        });
        compass.addTo(map);
        compass.on('click', function () {
          map.setRotation({
            rotation: 0,
            animate: true,
            duration: 0.5,
            finish: function () {
              // console.log('setRotation');
            }
          })
        });
        // this.delLine()

        floors = map.getLevels();
        for (const item of floors) {
          imgLayer[item] = [];
          textLayer[item] = [];
        }
        // 当前定位指向
        locationMarker = new fengmap.FMLocationMarker({
          url: '/images/preloader/map/pointer.png',
          size: 50,
          visible: false,
          height: 0.8,
          x: this.buildInfo.focusX || 12619607.715459315,
          y: this.buildInfo.focusY || 2621869.145377799,
          level: this.buildInfo.initFloor
        });
        locationMarker.addTo(map);
        locationMarker.visible = false;
        this.$emit('loadComplete', { map, locationMarker });
      });

      // 显示级别变化事件
      map.on('zoom', data => {
        this.$emit('scaleLevelChanged', data);
      });
      // 地图移动事件
      map.on('move', data => {
        // console.log('move', data);
        this.$emit('mapMove', data);
      });

      // 地图点击事件
      map.on('click', event => {
        // console.log('地图点击事件', event);
        this.clickMap(event);
      });
    },
    clickMap (event) {
      let targets = event.targets;
      let index = 0;
      // console.log(event, '地图点击');
      // console.log(targets[0], '点击事件类型-图片标注');
      if (!targets.length) { // 如果点击了空白区域
        return;
      }
      index = targets.findIndex(item => {
        return item.type === fengmap.FMType.IMAGE_MARKER
      })
      if (index === -1) {
        index = 0;
      } else {
        // 筛选点击类型
        event.findIndex = index;
        this.clickedPOI = false;
        event.isImage = true;
        let coords = {
          x: targets[index].x,
          y: targets[index].y,
          floor: targets[index].level
        };
        event.coords = coords;
        this.$emit('mapClickNode', event); // 点击了图片标注
        return;
      }
      if (event.nodeType === fengmap.FMType.NONE) { // 如果点击了空白区域
        return;
      }
      // 筛选点击类型
      event.findIndex = index;
      event.coords.floor = event.targets[index].level || map.getLevel();
      this.$emit('mapClickNode', event);
    },
    // 添加底层线（蜂鸟层级bug）
    delLine () {
      /* 构造线对象 */
      let segment = new fengmap.FMSegment();
      segment.points = [{
        x: this.buildInfo.focusX || 12619607.715459315,
        y: this.buildInfo.focusY || 2621869.145377799,
        z: 1
      }];
      /* 使用 level 参数定义要在哪个楼层上绘制线覆盖物 */
      segment.level = map.getLevel();
      /* 构造线 Marker */
      let lineMarker = new fengmap.FMLineMarker({
        segments: [segment],
        animate: false,
        smooth: true,
        width: 8,
        color: '#3eafff',
        depth: false
      });
      /* 向指定的地图添加 Marker，和 LocationMarker 一样，LineMarker 只能向 Map 添加，而不是其他类型 Marker 那样，向楼层对象添加 ，LineMarker 添加后无法修改其所在楼层 */
      lineMarker.addTo(map);
      setTimeout(() => {
        lineMarker.remove()
      }, 10)
    },
    addAMAP (mapTile) {
      console.log('addAMAP', mapTile);
      if (mapTile) {
        let mapTileArr = [fengmap.FMTileProvider.BAIDU_VECTOR, fengmap.FMTileProvider.AMAP_VECTOR, fengmap.FMTileProvider.TD_VECTOR]
        tileLayer = new fengmap.FMTileLayer({
          mode: mapTileArr[mapTile - 1]
        });
        tileLayer.addTo(map);
        return tileLayer;
      }
    },
    removeAMAP () {
      if (tileLayer) {
        tileLayer.remove(map);
        tileLayer = null;
      }
    },
    // 绘制路线（方法1）已走路线灰色
    drawLines (lineData, color = '#adadad') {
      // console.log('绘制路线（方法1）drawLines', lineData);
      let seg = new fengmap.FMSegment();
      for (let i = 0; i < lineData.length; i++) {
        let result = lineData[i];
        seg.level = result.groupId;
        seg.points = result.points;
      }
      let line = new fengmap.FMLineMarker({
        segments: [seg],
        animate: false,
        smooth: true,
        width: 8,
        color: color,
        depth: false
      });
      // console.log('line方法1', line);
      line.addTo(map);
      return line;
    },
    // 获取平滑线数据
    getLineData (lineData, color = '#33cc61') {
      // console.log('getLineData', lineData);
      let seg = new fengmap.FMSegment();
      seg.level = lineData[0].groupId;
      seg.points = lineData[0].points;
      console.log('points', seg.points);
      let line = new fengmap.FMLineMarker({
        segments: [seg],
        animate: false,
        smooth: true,
        width: 8,
        color: color,
        depth: false
      });
      lineLayer.push(line);
      console.log('line方法2', line);
      line.addTo(map);
      return line;
    },
    // 绘制多楼层路线
    drawMultiLineData (lineData, color = '#33cc61') {
      // console.log('drawMultiLineData', lineData);
      let segments = [];
      lineData.forEach(item => {
        let seg = new fengmap.FMSegment();
        seg.level = item.groupId;
        seg.points = item.points;
        segments.push(seg)
      })
      let line = new fengmap.FMLineMarker({
        segments: segments,
        animate: false,
        smooth: true,
        width: 8,
        color: color,
        depth: false
      });
      lineLayer.push(line);
      line.addTo(map);
      // console.log('line方法3', line);
      return line;
    },
    // 绘制路线（方法2）
    drawLineMark (lineData, color = '#3eafff') {
      // console.log('drawLineMark', lineData);
      let seg = new fengmap.FMSegment();
      seg.level = lineData.groupId;
      seg.points = lineData.points;
      console.log('points', seg.points);
      let line = new fengmap.FMLineMarker({
        segments: [seg],
        animate: false,
        smooth: true,
        width: 8,
        color: color,
        depth: false
      });
      lineLayer.push(line)
      console.log('line方法4', line);
      line.addTo(map);
      return line;
    },
    // 清除路线
    clearLines (line) {
      // console.log('清除线：', lineLayer);
      if (line) {
        line.remove();
      } else {
        if (lineLayer.length > 0) {
          lineLayer.forEach(item => {
            item.remove();
          });
          lineLayer = [];
        }
      }
    },
    // 清除所有图片标注和线段
    clearAllMarker () {
      for (let key in imgLayer) {
        imgLayer[key].forEach(item => {
          item.remove()
        });
      }
      for (let key in textLayer) {
        textLayer[key].forEach(item => {
          item.remove()
        });
      }
      lineLayer.forEach(item => {
        item.remove()
      });
    },
    // 设置导航路线起始点
    setNaviStartOrEndPoint (coord, type) {
      // 选择起始点时候清除导航线
      if (type === 1) { // 起点
        this.clearMarker(startMarker, 'imageMarker')
        startMarker = this.addImageMarker({
          x: coord.x,
          y: coord.y,
          level: coord.groupID,
          url: '/images/preloader/map/start.png',
          size: 40,
          height: 1.5
        });
      } else if (type === 0) { // 终点
        this.clearMarker(endMarker, 'imageMarker')
        endMarker = this.addImageMarker({
          x: coord.x,
          y: coord.y,
          level: coord.groupID,
          url: '/images/preloader/map/end.png',
          size: 40,
          height: 1.5
        });
      }
    },
    // 清除所有导航对象
    clearNaviAll () {
      startMarker && (startMarker.remove());
      endMarker && (endMarker.remove());
    },
    // 清除起始点对象
    clearStartMarker () {
      startMarker && (startMarker.remove());
    },
    // 添加图片标注
    addImageMarker (opt) {
      console.error('添加图片标注', opt);
      // 图标标注对象，默认位置为该楼层中心点
      opt.collision = false
      opt.level = opt.level || map.getLevel()
      let im = new fengmap.FMImageMarker(opt);
      imgLayer[opt.level].push(im);
      let floor = map.getFloor(opt.level);
      im.addTo(floor)
      return im;
    },
    // 添加自定义标注
    addDomMarker (opt) {
      // console.log('添加自定义标注', opt);
      opt.collision = false
      opt.level = opt.level || map.getLevel()
      let im = new fengmap.FMDomMarker(opt);
      imgLayer[opt.level].push(im);
      let floor = map.getFloor(opt.level);
      im.addTo(floor)
      return im;
    },
    // 添加文本标注
    addTextMarker (opt) {
      opt.level = opt.level || map.getLevel()
      let tm = new fengmap.FMTextMarker(opt);
      // 文本标注层添加文本Marker
      textLayer[opt.level].push(tm);
      let floor = map.getFloor(opt.level);
      tm.addTo(floor)
      return tm;
    },
    // 清除图片或文字标注
    clearMarker (marker, type) {
      if (!marker || !type) return;
      marker.remove()
    },
  }
};
</script>

<style lang="scss">
.fengmap {
  width: 100%;
  height: 100%;
  #map {
    width: 100%;
    height: 100%;
    &:focus-visible {
      outline: none;
    }
    > canvas {
      left: 0;
    }
    > div:nth-of-type(1) {
      width: 50px !important;
      height: 50px !important;
      transition: 0.5s;
      right: 40px !important;
      top: 100px !important;
    }
  }
  .fm-control-popmarker{
    width: auto !important;
    height: auto !important;
    padding: 0 !important;
    transform: translateY(18px);
  }
  .fm-control-popmarker input{
    display: none !important;
  }
  .fm-control-popmarker-bot,.fm-control-popmarker-top{
    border-width: 10px !important;
    left: 50% !important;
    bottom: -20px !important;
    transform: translateX(-50%) !important;
  }
  .fm-compass-container {
    width: 50px !important;
    height: 50px !important;
  }
  .fm-compass-element {
    width: 50px !important;
    height: 50px !important;
   }
}
@media (orientation: portrait) {
.fengmap {
  .fm-compass-container {
    transform: scale(2);
  }
  #map {
    > div:nth-of-type(1) {
      width: 50px !important;
      height: 50px !important;
      transition: 0.5s;
      right: 90px !important;
      top: 40px !important;
    }
  }
  }
}
</style>
